/** 规则脚本 context 标准字段名（与后端 IpcJsRuleContextKeys 一致） */
export const RULE_SCRIPT_CONTEXT_KEYS = {
  triggerPayload: 'triggerPayload',
  nodeContext: 'nodeContext',
  preparedData: 'preparedData',
} as const;

/** 手动测试 / 触发弹窗默认 content 示例（接口触发时作为 Body → content） */
export const DEFAULT_TEST_TRIGGER_PAYLOAD_JSON = `{
  "orderId": "SO-20260801"
}`;

export const DEFAULT_TEST_NODE_CONTEXT_JSON = `{
  "projectId": 3,
  "scheduleId": 5,
  "specScheduleId": 10,
  "skus": [
    {
      "id": 1001,
      "workItemId": "WI-001",
      "specName": "规格A",
      "skuCode": "SKU-A"
    }
  ],
  "milestoneId": 1,
  "milestoneName": "财务审核",
  "scheduleMilestoneId": 42
}`;

export const NODE_CONTEXT_FIELD_DOCS: { field: string; description: string }[] = [
  { field: 'projectId', description: '项目 ID（ipc_projects_tbl.id）' },
  { field: 'scheduleId', description: '排期版本 ID（ipc_schedules_tbl.id）' },
  { field: 'specScheduleId', description: '规格排期行 ID（ipc_spec_schedules_tbl.id）' },
  {
    field: 'skus',
    description:
      '关联 SKU 数组；无关联时为空数组 []。元素字段：id / workItemId / specName / skuCode',
  },
  { field: 'milestoneId', description: '里程碑节点配置 ID（ipc_milestone_nodes_tbl.id）' },
  { field: 'milestoneName', description: '里程碑节点名称' },
  { field: 'scheduleMilestoneId', description: '排期单元格 ID（ipc_schedule_milestones_tbl.id）' },
];

export function buildDefaultPrepareContextJson(): string {
  return JSON.stringify(
    {
      triggerPayload: JSON.parse(DEFAULT_TEST_TRIGGER_PAYLOAD_JSON),
      nodeContext: JSON.parse(DEFAULT_TEST_NODE_CONTEXT_JSON),
    },
    null,
    2,
  );
}

export function buildDefaultDecisionContextJson(): string {
  return JSON.stringify(
    {
      triggerPayload: JSON.parse(DEFAULT_TEST_TRIGGER_PAYLOAD_JSON),
      nodeContext: JSON.parse(DEFAULT_TEST_NODE_CONTEXT_JSON),
      preparedData: null,
    },
    null,
    2,
  );
}
